export const getAuthToken = () => {
  return localStorage.getItem('admin_token');
};

export const setAuthToken = (token) => {
  localStorage.setItem('admin_token', token);
};

export const removeAuthToken = () => {
  localStorage.removeItem('admin_token');
};

export const isAuthenticated = () => {
  return !!getAuthToken();
};

export const getAuthHeaders = () => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};